// Comisiones de las OTAs (7-oct-2026): la tarjeta del anuncio con el % que se queda cada
// canal, el IVA de esa comisión y si la ficha de la reserva enseña lo que de verdad llega.
// Panel: components/Gestores/OtaCommissionsPanel.vue
export const otaCommissions = {
  head: {
    title: "Commissions des OTA",
    sub: "Ce que chaque canal retient sur vos réservations. Ainsi, la fiche de chaque réservation vous donne une estimation de ce que vous recevez.",
  },
  loading: "Chargement des commissions…",
  loadError: {
    title: "Impossible de charger les commissions",
    text: "Vérifiez la connexion et réessayez.",
    retry: "Réessayer",
  },
  display: {
    title: "Prix des réservations OTA dans la fiche",
    totalLabel: "Uniquement le total envoyé par l'OTA",
    totalDesc: "Comme jusqu'à présent : le montant de la réservation.",
    netLabel: "Aussi ce que vous recevez",
    netDesc: "En plus du total, la fiche affiche la commission, la TVA sur la commission et le net que vous recevrez.",
  },
  rates: {
    title: "Commission et frais de chaque OTA",
    hint: "Indiquez le % affiché dans l'extranet de chaque OTA (sur Booking : « Commission et frais » ÷ « Prix total »). Si le canal transmet la commission réelle d'une réservation, c'est celle-ci qui est utilisée.",
    usual: "habituel : {pct} %",
    airbnbNote: "Airbnb vous verse un montant déjà net : sa commission est déjà déduite. Laissez vide (0 %) sauf si votre connexion reçoit le total.",
    managedNote: "Ces pourcentages sont aussi utilisés pour le reversement à votre propriétaire.",
  },
  vat: {
    title: "TVA sur la commission de l'OTA",
    hint: "Booking facture la TVA sur sa commission aux hébergements situés en Espagne (21 %) et la déduit du virement. Indiquez 0 si elle ne vous est pas facturée.",
  },
  errPercent: "Doit être un pourcentage entre 0 et 100.",
  example: {
    title: "Exemple",
    sub: "Une réservation {channel} de {total}",
    total: "Prix total",
    commission: "Commission et frais de {channel} ({pct} %)",
    vat: "TVA sur la commission ({pct} %)",
    net: "Vous recevez",
    foot: "C'est une estimation avec ces pourcentages : l'OTA peut virer un montant légèrement différent (arrondis, promotions, frais de paiement). Si le canal transmet la commission réelle, la fiche utilise celle-ci.",
  },
  footer: {
    save: "Enregistrer",
    saving: "Enregistrement…",
    saved: "Commissions enregistrées",
    unsaved: "Modifications non enregistrées",
    fixErrors: "Vérifiez les champs signalés",
    errSave: "Impossible d'enregistrer les modifications. Réessayez.",
    errInvalid: "La commission de chaque OTA doit être un pourcentage entre 0 et 100.",
  },
};
